import Shortcuts from "./ShortcutsBtn";
import InstallBox from "./InstallBox";
import { IMAGE_DNS } from "../../utils/config/Config";
import Wrapper from "../../styles/Wrapper";
import { t } from "i18next";
import "./NotSupport.scoped.scss";

function NotSupport() {
  return (
    <Wrapper title="" isFooter={false}>
      <div id="NotSupport" className="clearfix">
        <div className="guide-top">
          <div className="guide-funny">
            <img
              src={
                IMAGE_DNS +
                "/Valofe_file/web/vfun/images/vfun_lounge/images/funny-browser-gude.png"
              }
            />
          </div>
          <div className="text">
            {t("VFUN 라운지는 Chrome 또는 Edge에 최적화 되어 있습니다.")}
          </div>
          <div className="btns">
            <Shortcuts point="이상" num="1" />
            <Shortcuts point="이하" num="2" />
          </div>
        </div>
        <div className="guide-bottom">
          <InstallBox point="미만" num="2" />
          <InstallBox point="이상" num="1" type="edge" />
        </div>
      </div>
    </Wrapper>
  );
}

export default NotSupport;
